import { Provider, APP_INITIALIZER } from '@angular/core';
import { EnvironmentLoader } from './environment-loader.util';

export const providerEnvironment: () => Provider = () => ({
  provide: APP_INITIALIZER,
  useFactory: () => () => EnvironmentLoader.loadEnvironment(),
  multi: true,
});
